import React, {Fragment} from "react";
import image from '../../../images/situation/maten/kozijn/K.jpg'

export default function MaatK(props) {
    return <Fragment>
        <div className="addtextMore">
            Hier kunt u de breedte van de kozijnstijl invullen.
        </div>
        <img className="explainImage" src={image} alt=""/>
    </Fragment>;
}